import { PERMISSIONS } from "modules/PermissionsConstants";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { hierarchyTypeModalState, isEditHierarchy } from "../atoms/atoms";
import CustomLoader from "components/CustomLoader";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import CloseIconButton from "components/CloseIconButton";
import AddButton from "components/AddButton";
import EditOutlineButton from "components/EditOutlineButton";
import HierarchyLeadershipView from "./HierarchyLeadershipView";
import HierarchyGeneralInfo from "./HierarchyGeneralInfo";
import { useGetParentHierarchyById } from "../hooks/useGetParentHierarchyById";
import HierarchyActivityHistory from "./HierarchyActivityHistory";
import AssociatedHierarchy from "./AssociatedHierarchy";
import HierarchySystemInformation from "./HierarchySystemInformation";
import { MapIcon } from "@heroicons/react/24/solid";

const HierarchyView = ({
  hierarchyId,
  isParent,
  onclickHierarchyName,
  hierarchyData,
  handleEdit,
  onClickCancelShow,
}) => {
  //#region Data
  const { data, isFetching } = useGetParentHierarchyById(hierarchyId, isParent);

  const setShowHierarchyTypeModal = useSetRecoilState(hierarchyTypeModalState);
  const setEditState = useSetRecoilState(isEditHierarchy);

  //#region Permissions
  const addPermission = PERMISSIONS.permission_hierarchy_add;
  const editPermission = PERMISSIONS.permission_hierarchy_update;
  const viewPermission = PERMISSIONS.permission_hierarchy_view;
  const userPermissions = useRecoilValue(permissionsSelector);

  const onClickParentHierarchy = (data) => {
    onclickHierarchyName(data, false);
  };

  return (
    <div className="py-2">
      {!isFetching ? (
        <>
          <div className="relative mx-8 my-4 px-2 text-xs py-2 box-shadow border-quinary border-l-2">
            <CloseIconButton
              onClick={() => {
                onClickCancelShow();
              }}
            />
            <div className="flex mx-2 justify-between pb border-secondary border-b-2">
              <div className="flex gap-2 items-center pb-2">
                <div>
                  <MapIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                </div>
                <div className="flex flex-col leading tight">
                  <h3 className="text-xs font-medium text-gray-500">
                    SPLC Hierarchy
                  </h3>
                  <h1 className="mr-auto font-bold text-primary text-md uppercase">
                    {data?.hierarchyName}
                  </h1>
                </div>
              </div>
              <div className="flex justify-between">
                <div className="flex items-center gap-2">
                  {userPermissions.includes(addPermission) && (
                    <AddButton
                      buttonText="Add"
                      onClick={() => {
                        setShowHierarchyTypeModal(true);
                      }}
                      className={undefined}
                      disabled={undefined}
                    />
                  )}
                  {userPermissions.includes(editPermission) && (
                    <EditOutlineButton
                      buttonText="Edit"
                      onClick={() => {
                        handleEdit(data);
                        setEditState(true);
                      }}
                      className={undefined}
                      disabled={undefined}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="bg-bgDB">
              {userPermissions.includes(viewPermission) && data && (
                <>
                  <HierarchyGeneralInfo
                    data={data}
                    onClickParentHierarchy={onClickParentHierarchy}
                    hierarchyData={hierarchyData}
                  />
                  <HierarchyLeadershipView data={data} />
                  <AssociatedHierarchy
                    hierarchyData={data}
                    onClickParentHierarchy={onClickParentHierarchy}
                  />
                  <HierarchyActivityHistory hierarchyData={data} />
                  <HierarchySystemInformation hierarchyData={data} />
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <div>
          <CustomLoader />
        </div>
      )}
    </div>
  );
};

export default HierarchyView;
